import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import { Header, Segment, Icon, Message } from "semantic-ui-react";
import Qs from "qs";
import { FrontSiteRoutes } from "@routes/urls";
import Overridable from "react-overridable";
import ClearButton from "@modules/SearchControls/ClearButton";
import { SearchMessage } from "@modules/SearchControls/SearchMessage";
import { SuggestedRelatedMaterials } from "@modules/SearchControls/SuggestedRelatedMaterials";
import { sessionManager } from "@authentication/services/SessionManager";

const SearchEmptyResults = ({ queryString, resetQuery, extraContent }) => {
  const onClickBookRequestLink = () => {
    const params = Qs.parse(window.location.search);
    const queryString = params["?q"];
    return {
      pathname: FrontSiteRoutes.documentRequestForm,
      state: { queryString },
    };
  };

  const isFacultyUser = () => {
    const user = sessionManager?.user;
    if (!user) return false;

    // Check if user has faculty user type
    const isFaculty = user?.userType?.some((type) => {
      const userType = type.user_type?.toLowerCase();
      return userType === "faculty";
    });

    return isFaculty;
  };

  const renderRequestMessage = () => {
    // Only render for faculty users (including librarians and admins)
    if (!isFacultyUser()) {
      return null;
    }

    const requestFormLink = (
      <Link className="primary" to={onClickBookRequestLink()}>
        this form
      </Link>
    );

    return (
      <Message icon color="orange" size="mini">
        <Icon name="info circle" />
        <Overridable id="SearchResults.NoResults.extra">
          <Message.Content>
            <h4 className="search-no-results-extra">
              Would you like to request this material? Please fill{" "}
              {requestFormLink}.
            </h4>
          </Message.Content>
        </Overridable>
      </Message>
    );
  };

  return (
    <SearchMessage
      title={queryString ? `No results found for` : "No results found"}
      icon="search"
    >
      {queryString && (
        <>
          <Segment.Inline>
            <Header as="h1">"{queryString}"</Header>
            {/* Only show request message to faculty users */}
            {renderRequestMessage()}
            <ClearButton clickHandler={resetQuery} />
            {extraContent}
          </Segment.Inline>
        </>
      )}

      <SuggestedRelatedMaterials />
    </SearchMessage>
  );
};

SearchEmptyResults.propTypes = {
  queryString: PropTypes.string,
  resetQuery: PropTypes.func,
  extraContent: PropTypes.node,
};

SearchEmptyResults.defaultProps = {
  queryString: "",
  resetQuery: null,
  extraContent: null,
};

export default SearchEmptyResults;
